export const OPEN_EVENT_SELECTOR_MODAL = 'OPEN_EVENT_SELECTOR_MODAL';
export const CLOSE_EVENT_SELECTOR_MODAL = 'CLOSE_EVENT_SELECTOR_MODAL';
